import { JuloUpdateEntry } from "./types"

export const newNavigationEntry: JuloUpdateEntry = {
  slug: "2026-10-01-new-navigation",
  date: "2026-10-01",
  title: "Ny meny i Alfred",
  description:
    "Vi har gjort om menyn i Alfred. Sidopanelen är uppdelad i grupper som Verksamhet, Kundhantering och Administration, och sidorna i den grupp ni befinner er i visas som flikar högst upp på sidan.\n\nHögst upp i högra hörnet finns nu alltid samma knappar, oavsett vilken sida ni är på:\n\n- Plus – skapa en bokning eller ta emot en drop-in\n- Förstoringsglaset – sök efter ett jobb\n- Pratbubblan – gå till meddelandena\n\nDen nya menyn rullas ut till några butiker i taget, så det kan dröja ett tag innan den dyker upp hos er.",
  images: [
    {
      src: "/julo-updates/2026-10-01-new-navigation/1-ny-meny.png",
      alt: "Kalendern med den nya menyn. Till vänster visas sidopanelen med grupperna Verksamhet, Kundhantering, Cykelförsäljning, Analys och Administration. Högst upp visas flikarna Översikt, Kalender, Ta emot drop-in, Skapa bokning, Produkter och QR-kod för incheckning, och i högra hörnet knapparna för snabbåtgärder, sök, meddelanden och hjälp.",
    },
  ],
}
